import { Alert, Box, Button, Flex, Typography } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { KycStatus } from '../../../api/kycStatus/kycStatus';
import { CopyVerifiedAddress } from '../../../common/components/CopyVerifiedAddress/CopyVerifiedAddress';
import { FormTitle } from '../../../common/components/FormTitle/FormTitle';
import { openKycModal } from '../../KycListener/KycListener';
import { ReactComponent as DiscordIcon } from './discord.svg';

export interface KycStateProps {
  readonly kycStatus: KycStatus;
}

export const KycState: FC<KycStateProps> = ({ kycStatus }) => {
  const handleKycButtonClick = () => {
    if (kycStatus !== KycStatus.LOADING) {
      openKycModal();
    }
  };

  const isRedKycStage = [KycStatus.RETRY, KycStatus.REJECTED].includes(
    kycStatus,
  );

  return (
    <Box borderRadius="l" padding={4}>
      <Flex col>
        <Flex.Item marginBottom={6}>
          <FormTitle content="Read the IDO guidelines and pass the KYC to participate">
            KYC
          </FormTitle>
        </Flex.Item>
        {isRedKycStage ? (
          <Flex.Item marginBottom={6}>
            <Alert
              type="error"
              showIcon
              message={
                <Typography.Body>
                  Your verification was rejected for some reason. Please check
                  the reason and contact us if you don’t agree with results
                </Typography.Body>
              }
            />
          </Flex.Item>
        ) : (
          <Flex.Item marginBottom={6}>
            <Alert
              type="warning"
              showIcon
              message={
                <Typography.Body>
                  DO NOT SPAM THE KYC FORM WITH FILES OR IT WILL REJECT YOU. If
                  you have a problem with Proof of address, contact us first
                </Typography.Body>
              }
            />
          </Flex.Item>
        )}

        {kycStatus !== KycStatus.REJECTED ? (
          <div onClick={handleKycButtonClick}>
            <Button
              size="large"
              width="100%"
              type="primary"
              loading={
                kycStatus === KycStatus.IN_PROGRESS ||
                kycStatus === KycStatus.LOADING
              }
            >
              {kycStatus === KycStatus.LOADING && 'Loading KYC'}
              {kycStatus === KycStatus.IN_PROGRESS && 'Processing KYC'}
              {kycStatus === KycStatus.RETRY && 'Retake KYC'}
              {kycStatus === KycStatus.EMPTY && 'Start KYC'}
            </Button>
          </div>
        ) : (
          <Button onClick={handleKycButtonClick} size="large" width="100%">
            Check KYC status
          </Button>
        )}
        {isRedKycStage && (
          <>
            <Flex.Item marginTop={2}>
              <CopyVerifiedAddress>
                <Button type="link" size="large" width="100%">
                  Copy veryfied addresses
                </Button>
              </CopyVerifiedAddress>
            </Flex.Item>
            <Flex.Item alignSelf="center">
              <Button
                href="https://discord.gg/kGp44bdpq7"
                target="_blank"
                type="link"
                size="large"
                style={{ padding: 0 }}
              >
                <Flex align="center">
                  <Flex.Item marginRight={2} display="flex">
                    <DiscordIcon />
                  </Flex.Item>
                  Contact Us
                </Flex>
              </Button>
            </Flex.Item>
          </>
        )}
      </Flex>
    </Box>
  );
};
